// Setzt die gepflegte Jahreszahl (.catalogDownload__watermark) buendig an die rechte Kante
// von .catalogDownload__visual - und damit an die echte Bildschirmkante, weil dieses Element
// per "right: calc(50% - 50vw)" bis dorthin bleedet (siehe _catalogDownload.scss).
//
// Warum per JS und nicht einfach "right: 0" im CSS: die Zahl steht per rotate(-90deg)
// gedreht. "right" wirkt auf die UNgedrehte Box (Breite/Hoehe vertauscht gegenueber dem, was
// man sieht), die Drehung erfolgt danach um den Mittelpunkt. Bei einem z.B. 374px breiten,
// 150px hohen Textblock landet die sichtbare Kante dadurch ~112px vom Rand entfernt, obwohl
// "right: 0" gesetzt ist. Statt das je Textlaenge/Schriftgroesse zurueckzurechnen, wird hier
// gemessen: auf Nullpunkt setzen, Ist-Abstand messen, per Differenz auf 0 korrigieren.
export function initCatalogDownloadWatermark() {
    const TARGET_GAP = 0;

    function position(visual) {
        const watermark = visual.querySelector(".catalogDownload__watermark");
        if (!watermark) return;

        const visualRect = visual.getBoundingClientRect();
        if (!visualRect.width) return;

        watermark.style.right = "0px";
        const currentGap = visualRect.right - watermark.getBoundingClientRect().right;
        const correction = TARGET_GAP - currentGap;
        watermark.style.right = `${correction.toFixed(1)}px`;
    }

    function run() {
        document.querySelectorAll(".catalogDownload__visual").forEach(position);
    }

    run();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 120);
    });
}
